//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: ['article'],
  data() {
    return {
      currentTag: '',
    };
  },

  watch: {
    $route: {
      handler() {
        this.currentTag = this.$route.params.type
          ? this.$route.params.type
          : '';
      },
      deep: true,
    },
  },
  mounted() {
    this.currentTag = this.$route.params.type ? this.$route.params.type : '';
  },
};
